"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/VideoRooms/List/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);




var _List = require('web/screens/App/List');
var _Add = require('web/components/Add'); var _Add2 = _interopRequireDefault(_Add);
var _RoomsList = require('web/screens/VideoRooms/List/RoomsList'); var _RoomsList2 = _interopRequireDefault(_RoomsList);
var _ListMenuNotice = require('web/components/Upsells/ListMenuNotice'); var _ListMenuNotice2 = _interopRequireDefault(_ListMenuNotice);










// memo keeps the PureComponent bailout on unchanged props.
const VideoRoomsList = _react.memo.call(void 0, function VideoRoomsList ({
  gotoRoom, currentRoomKey,
  hasVideoFeature, onRequestVideoFeature,
  openMobileNewRoomModal, openDesktopNewRoomModal,
}) {
  // Rendered as a component (`<AddBtn />`), so its identity must stay put or
  // the buttons remount; the class method never changed. The openers come
  // from useCallback([]) in the app root, so this never changes either.
  const renderAddBtn = _react.useCallback.call(void 0, () => (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_Add2.default, {
        className: "blmh-desktop-hide meeting-rooms--add-btn" ,
        onClick: openMobileNewRoomModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}
      )
      , _react2.default.createElement(_Add2.default, {
        className: "blmh-mobile-hide meeting-rooms--add-btn" ,
        onClick: openDesktopNewRoomModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}
      )
    )
  ), [openMobileNewRoomModal, openDesktopNewRoomModal])

  return (
    _react2.default.createElement(_List.List, { className: "meeting-rooms--list", __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}
      , _react2.default.createElement(_List.ListHeaderWrapper, { className: "meeting-rooms--header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}
        , _react2.default.createElement(_List.ListHeaderWithSlotAddButton, { AddBtn: renderAddBtn, __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}
          , _react2.default.createElement(_List.ListHeaderTitle, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}, "Video Meetings" )
        )
      )
      , _react2.default.createElement(_List.ListItemsWrapper, { className: "meeting-rooms--list-items", __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}
      ,  hasVideoFeature
        ? (
          _react2.default.createElement(_RoomsList2.default, {
            gotoRoom: gotoRoom,
            currentRoomKey: currentRoomKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}
          )
          ) : (
          _react2.default.createElement(_ListMenuNotice2.default, {
            onRequest: onRequestVideoFeature,
            desc: "Upgrade for video calls with patients and coworkers."       , __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}}
          )
          )
      
      )
    )
  )
})

exports. default = VideoRoomsList
